import React from 'react';
import './App.css';

function App() {
  const handleVisit = () => {
    window.location.href = 'https://sitesprint.app';
  };

  return (
    <div className="App">
      <div className="container">
        <div className="content">
          <h1 className="title">We've Moved!</h1>
          <p className="message">
            Our new home is now at <span className="highlight">sitesprint.app</span>
          </p>
          <button className="visit-button" onClick={handleVisit}>
            Visit sitesprint.app
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
